import React, { useEffect, useState, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Drawer, Popconfirm,
} from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import closeIcon from '@Images/icons/icon-close-blue.png';
import ExpenseActions from '@Actions/purchase/expense/expenseActions';
import ExpenseAccountForm from '../../../Common/SelectExpenseAccount/ExpenseAccountForm';
import './style.scss';

/**
 *
 */
const ExpenseAccount = ({
  user, getAccount, accounts, getAccountLoading, deleteAccount, deleteAccountLoading,
}) => {
  const [showNewAccountModal, setShowNewAccountModal] = useState(false);

  const [showUpdateAccountModal, setShowUpdateAccountModal] = useState(false);

  const [selectedAccount, setSelectedAccount] = useState({});

  useEffect(() => {
    getAccount(user?.tenant_info?.tenant_id);
  }, []);

  const expenseAccounts = accounts?.account?.accounts;

  const accountColumns = [
    {
      title: 'ACCOUNT',
      render: (text, record) => (
        <Fragment>
          {/* eslint-disable-next-line eqeqeq */}
          {record?.account_name}
        </Fragment>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <div style={{
          textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center',
        }}
        >
          <div
            className="roundIconButton"
            onClick={() => {
              setShowUpdateAccountModal(true);
              setSelectedAccount(record);
            }}
          >
            <EditOutlined />
          </div>
          <Popconfirm
            placement="topRight"
            title="Are you sure you want to delete this account?"
            onConfirm={() => deleteAccount({
              tenant_id: user?.tenant_info?.tenant_id,
              account_id: record?.account_id,
            }, () => {
              getAccount(user?.tenant_info?.tenant_id);
            })}
            okText="Yes"
            cancelText="No"
          >
            <div
              className="deleteButton"
            >
              <DeleteOutlined />
            </div>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <Fragment>
      <div className="expense-account__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-18">
            <div className="expense-account__table__wrapper">
              <div className="expense-account__table__data hide__in-mobile">
                <Table
                  title={() => (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      {`${expenseAccounts?.length || '0'} ${'Account(s)'}`}
                      <Fragment>
                        {Helpers.getPermission(Helpers.permissionEntities.EXPENSES,
                          Helpers.permissionTypes.CREATE, user) && (
                          <H3Button
                            buttonType={defaultButtonTypes.BLUE_ROUNDED}
                            text="+ New Account"
                            onClick={() => setShowNewAccountModal(true)}
                            customClass="expense-account__header__add-button hide__in-mobile"
                          />
                        )}
                      </Fragment>
                    </div>
                  )}
                  loading={getAccountLoading || deleteAccountLoading}
                  showHeader
                  size="small"
                  scroll="scroll"
                  columns={accountColumns}
                  dataSource={expenseAccounts || []}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Drawer
        open={showNewAccountModal}
        width="360px"
        mask
        onClose={() => setShowNewAccountModal(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '315px' }}>
            <H3Text text="Add New Account" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowNewAccountModal(false)} />
          </div>
        </div>
        <div className="create-po__new-vendor-wrapper">
          <ExpenseAccountForm
            callback={() => {
              getAccount(user?.tenant_info?.tenant_id);
              setShowNewAccountModal(false);
            }}
          />
        </div>
      </Drawer>
      <Drawer
        title="Update Account"
        open={showUpdateAccountModal}
        onClose={() => setShowUpdateAccountModal(false)}
        width="360px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '315px' }}>
            <H3Text text="Update Account" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowUpdateAccountModal(false)} />
          </div>
        </div>
        <ExpenseAccountForm
          selectedAccount={selectedAccount}
          callback={() => {
            getAccount(user?.tenant_info?.tenant_id);
            setShowUpdateAccountModal(false);
          }}
        />
      </Drawer>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, ExpenseReducers }) => ({
  user: UserReducers.user,
  accounts: ExpenseReducers.accounts,
  getAccountLoading: ExpenseReducers.getAccountLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getAccount: (tenantId, page, limit, searchKeyword, callback) => dispatch(ExpenseActions.getAccount(tenantId, page, limit, searchKeyword, callback)),
  deleteAccount: (payload, callback) => dispatch(ExpenseActions.deleteAccount(payload, callback)),
});

ExpenseAccount.propTypes = {
  user: PropTypes.any,
  accounts: PropTypes.any,
  getAccount: PropTypes.func,
  getAccountLoading: PropTypes.bool,
  deleteAccount: PropTypes.func,
  deleteAccountLoading: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ExpenseAccount));
